<template>
  <div>
    <div class="card" v-if="isHost || showScoreButtons">
      <div class="card-header">Scoring</div>
      <div class="card-body">
        <div class="container-fluid">
          <div class="row" v-if="isHost || quizStarted">
            <QuizScoringButton
              v-for="round in rounds"
              v-bind:key="round.id"
              v-bind:round="round"
              @scoring-requested="scoringRequested"
            />
          </div>
          <div v-else>Waiting for your host to start the quiz.</div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-scoring"
      v-model="isScoringModalVisible"
      title="Score round"
      centered
      @ok="scoreSelected"
    >
      <p class="my-2" v-if="selectedRound">
        <b-form-select
          v-model="selectedScore"
          v-if="selectedRound.allow_half_points == 0"
          autofocus
        >
          <option
            v-for="(i, n) in maxScorePlusOne"
            v-bind:key="n"
            v-bind:value="n"
          >
            {{ n }}
          </option>
        </b-form-select>
        <b-form-select v-model="selectedScore" v-else autofocus>
          <option
            v-for="(i, n) in doubleMaxScorePlusOne"
            v-bind:key="n"
            v-bind:value="n / 2"
          >
            {{ n / 2 }}
          </option>
        </b-form-select>
      </p>
    </b-modal>
    <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DialogError from "@/components/DialogError";
import QuizScoringButton from "@/components/QuizScoringButton";

export default {
  name: "QuizScoring",
  props: {
    quizID: {},
    scoreTeamID: {
      default: null
    },
    isHost: {
      default: false
    }
  },
  components: {
    QuizScoringButton,
    DialogError
  },
  data() {
    return {
      quiz: {},
      rounds: {},
      isScoringModalVisible: false,
      selectedRound: null,
      selectedScore: 0,
      errorVisible: false,
      errorMessage: ""
    };
  },
  computed: {
    ...mapGetters("teamStore", { activeTeamID: "activeTeamID" }),
    showScoreButtons() {
      return !this.quizEnded;
    },
    quizStarted() {
      if (Object.keys(this.quiz).length == 0) {
        return false;
      }
      return this.quiz.status >= this.$tqConstants["QUIZ_STATUS_RUNNING"];
    },
    quizEnded() {
      if (Object.keys(this.quiz).length == 0) {
        return false;
      }
      return this.quiz.status >= this.$tqConstants["QUIZ_STATUS_ENDED"];
    },
    maxScorePlusOne() {
      if (!this.selectedRound.score_max) {
        return 0;
      }

      return this.selectedRound.score_max + 1;
    },
    doubleMaxScorePlusOne() {
      if (!this.selectedRound.score_max) {
        return 0;
      }

      return this.selectedRound.score_max * 2 + 1;
    },
    teamToScoreFor() {
      if (this.scoreTeamID) {
        return this.scoreTeamID;
      }

      return this.activeTeamID;
    }
  },
  methods: {
    scoringRequested(roundID) {
      this.selectedRound = this.rounds[roundID];
      this.selectedScore = this.selectedRound.score;
      if (this.selectedScore.length == 0) {
        this.selectedScore = 0;
      }
      this.isScoringModalVisible = true;
    },
    scoreSelected() {
      if (!this.selectedRound) {
        return;
      }

      this.$topquiz.sendCommand(
        "score",
        this.$topquiz.SessionKey,
        this.teamToScoreFor,
        this.selectedRound.id,
        this.selectedScore
      );
    },
    setQuiz(quiz, rounds) {
      this.quiz = quiz;
      this.setRounds(rounds);
    },
    setRounds(roundList) {
      roundList.forEach(round => {
        this.$set(round, "score", "");
        this.$set(this.rounds, round.id, round);
      });
    }
  },
  created() {
    // must be called by parent
    this.$topquiz.on(this, "getQuizData_success", params => {
      this.quiz = params[0];
      var roundList = params[1];
      this.setRounds(roundList);
    });

    this.$topquiz.on(this, "score_ok", params => {
      var scoreList = params[0];
      scoreList.forEach(item => {
        this.$set(this.rounds[item.round_id], "score", item.score);
      });
    });

    this.$topquiz.on(this, "score_error", params => {
      var error = params[0];
      if (error == -1) {
        error =
          "Your host is not ready for your scores yet. Please wait until they start the quiz.";
      } else if (error == -2) {
        error = "This quiz has ended. No scores can be submitted anymore.";
      } else if (error == -3) {
        error =
          "This quiz has been finalized. No scores can be changed anymore.";
      }
      this.errorMessage = error;
      this.errorVisible = true;
    });

    this.$topquiz.on(this, "getMyScore_success", params => {
      var scoreList = params[0];
      scoreList.forEach(item => {
        this.$set(this.rounds[item.round_id], "score", item.score);
      });
    });

    this.$topquiz.on(this, "score_update", params => {
      var scoreList = params[0];
      scoreList.forEach(item => {
        var team = item[0];
        if (team != this.teamToScoreFor) {
          return;
        }
        var round = item[1];
        var score = item[2];

        this.$set(this.rounds[round], "score", score);
      });
    });

    this.$topquiz.on(this, "quizStatusChanged", params => {
      if (this.quiz.id == params[0]) {
        this.quiz.status = params[1];
      }
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  }
};
</script>
